import http from './http.config'

export type CompanyInfo = {
  name: string
  description?: string
  logoUrl?: string
}

export const fetchCompanyInfo = () =>
  http.get('/about').then((res) => res.data as CompanyInfo)


// Vendor (authenticated) dashboard summary
export const fetchCompanyDashboardSummary = (params = {}) =>
  http.get('/company/dashboard/summary', { params }).then((res) => res.data.summary)

// Vendor (authenticated) dashboard summary
export const fetchCompanyCredential = (companyId: number) =>
  http.get(`/companies/${companyId}/credential`).then((res) => res.data)
